import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getTaskPriorities } from '../Task.api'

import { TASK_PRIORITY_SELECT_DROPDOWN_FLOATING_CONFIG } from './TaskPrioritySelect.constants'
import { toTaskPrioritySelectItems } from './TaskPrioritySelect.utils'
import { TaskPrioritySelectItemContent } from './TaskPrioritySelectItemContent'

function TaskPrioritySelect({
  Control = InputSelectControl,
  controlProps,
  dropdownFloatingConfig = TASK_PRIORITY_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData = getTaskPriorities,
  listProps,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      controlProps={{
        ...controlProps,
        contentProps: {
          ...controlProps?.contentProps,
          ValueItem:
            controlProps?.contentProps?.ValueItem ||
            TaskPrioritySelectItemContent,
        },
      }}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      listProps={{
        ...listProps,
        itemProps: {
          ...listProps?.itemProps,
          contentProps: {
            ...listProps?.itemProps?.contentProps,
            Info:
              listProps?.itemProps?.contentProps?.Info ||
              TaskPrioritySelectItemContent,
          },
        },
      }}
      toPreparedItems={toTaskPrioritySelectItems}
    />
  )
}

export default TaskPrioritySelect
